import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[scep-func]'
})
export class ScepFuncDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}